import {ERROR_STORE_NAME} from '../reducers/reducers'

export function getErrorItems(state) {
    const stored = state[ERROR_STORE_NAME] || { }
    return stored.items
}
